
import { CalendarClock, CheckCircle2, Loader2 } from "lucide-react";
import { usePendingTasks, TaskItem } from "@/hooks/use-tasks";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function UpcomingTasks() {
  const { tasks, isLoading, error } = usePendingTasks();

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-32 w-full">
        <Loader2 className="h-6 w-6 text-primary animate-spin" />
        <p className="text-sm text-muted-foreground mt-2">Carregando tarefas...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-32 w-full">
        <p className="text-sm text-muted-foreground">{error}</p>
        <Button variant="outline" size="sm" className="mt-2" onClick={() => window.location.reload()}>
          Tentar novamente
        </Button>
      </div>
    );
  }

  if (tasks.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-32 w-full">
        <p className="text-sm text-muted-foreground">Não há tarefas pendentes</p>
        <Link to="/workflow">
          <Button variant="outline" size="sm" className="mt-2">
            Adicionar tarefa
          </Button>
        </Link>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {tasks.map((task) => (
        <div
          key={task.id}
          className="flex items-center justify-between rounded-md border p-4"
        >
          <div className="space-y-1">
            <p className="text-sm font-medium">{task.title}</p>
            <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 text-xs text-muted-foreground">
              <div className="flex items-center gap-1">
                <CalendarClock className="h-3 w-3" />
                <span>{new Date(task.dueDate).toLocaleDateString()}</span>
              </div>
              {task.client && (
                <span className="text-xs text-primary">{task.client}</span>
              )}
            </div>
          </div>
          {task.status === "completed" ? (
            <CheckCircle2 className="h-4 w-4 text-green-500" />
          ) : null}
        </div>
      ))}
      
      <Link to="/workflow" className="block">
        <Button variant="outline" size="sm" className="w-full">
          Ver todas as tarefas
        </Button>
      </Link>
    </div>
  );
}
